<template lang="pug">
  #save
    font-awesome-icon(icon="spinner" spin)
    span Encurtando seu link...
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import axios from 'axios'

export default {
  name: 'Save',
  components: {
    FontAwesomeIcon
  },
  props: [
    'url'
  ],
  created () {
    this.save()
  },
  methods: {
    save () {
      // router = this.$router
      axios.post(`${process.env.FUNCTIONS_BASE}/createUrl`, {
        original: this.url
      })
      .then(this.show)
      .catch(this.error)
    },
    show (result) {
      this.$router.push({
        name: 'show',
        params: {
          id: result.data
        }
      })
    },
    error (err) {
      this.$router.push({
        name: 'error',
        params: {
          error: err,
          url: this.url
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  span
    margin-left 1rem
</style>



// WEBPACK FOOTER //
// src/components/Save.vue